import type { ActiveBlockCard } from '@/features/editor/constants/blockTypeMatrix'
import type { PreviewRun } from '../preview/previewRun'

/** Какие варианты примера показаны отмеченными (индексы `blockSamples`). */
const PICKED: Partial<Record<ActiveBlockCard['id'], number[]>> = {
  'quiz-single': [0],
  'quiz-multi': [0, 1, 3],
}

/**
 * Застывшее «прохождение» для примера в окне «Добавить блок»: у квиза с
 * вариантами сразу видно, как выглядит выбор — одна галочка или несколько.
 * Ничего не проверяет и никуда не ведёт: пример не кликабелен.
 */
export const blockSampleRun = (card: ActiveBlockCard): PreviewRun | undefined => {
  const selected = PICKED[card.id]
  if (!selected) return undefined
  return {
    answer: { kind: 'options', selected },
    setAnswer: () => {},
    verdict: null,
    ctaState: 'idle',
    ctaLabel: null,
    ctaDisabled: false,
    onCta: () => {},
    visitKey: 0,
  }
}
